// extracted by mini-css-extract-plugin
module.exports = {"blue-button":"blueButton_blue-button__jhUNx","disabled-opacity":"blueButton_disabled-opacity__OHuhG","disabled":"blueButton_disabled__1NCvz"};